
export const leaf = 'config';
export const initialState = {
  randome: 0
}



// WEBPACK FOOTER //
// ./src/sdk/config/const.js